import NavNode from '@/services/NavigationNode';

const flatmap = function (map: Map<string, NavNode> , children: NavNode []): Map<string, NavNode> {
	let root = map;
	children.forEach((i: NavNode) => {
		root.set(i.uid || '', i);
		root = flatmap(root, i.nodes);
	});
	return root;
};

export default flatmap;